mutation createMarket($name: String!, $symbol: String!, $type: String!, $is_enabled: Boolean!) {
    createMarket(name: $name, symbol: $symbol, type: $type, is_enabled: $is_enabled)
}
